var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loadingPartnerFigures)?_c('p',{staticClass:"text-center"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('common.pages.partner.figuresGlobal', { global: _vm.globalCount }))}}),_vm._v(" "),(_vm.newWeekly > 1)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('common.pages.partner.figuresWeekly', { weekly: _vm.newWeekly }))}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }